const benefits = [
    {
        title: "Estudia online en vivo o a tu ritmo, tú elijes",
        body: "Tenemos todas las opciones para ti: Clases online en vivo, Clases en video cn feedback online en vivo, Clases en video para aprender a tu ritmo.",
    },
    {
        title: "Entrenamientos Especializados",
        body: "Te ofrecemos entrenamientos especializados. Somos especialistas en el desarrollo de contenidos digitales con alto impacto en innovación.",
    },
    {
        title: "Alcanza un nivel superior en corto tiempo",
        body: "Con nuestros másteres llegarás a niveles avanzados en menos de un año.",
    },
    {
        title: "Maestros especialistas",
        body: "Los maestros no son generalistas. Nuestros maestros son especialistas en cada una de las áreas y con experiencia en la industria real.",
    },
    {
        title: "Premiamos la excelencia",
        body: "Brindamos becas a los estudiantes que obtengan resultados excelentes.",
    },
    {
        title: "Estudia 100% online desde cualquier parte del mundo",
        body: "No limites tu aprendizaje, hoy puedes estudiar desde cualquier parte del mundo de habla hispana.",
    },
];


export default benefits;